define(["exports", "react", "styled-components", "react-intl-universal", "../.."], function (_exports, _react, _styledComponents, _reactIntlUniversal, _) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  var FormContainer = _styledComponents.default.form.withConfig({
    displayName: "CommentForm__FormContainer",
    componentId: "sc-2dub3o-0"
  })(["margin-left:20px;padding:16px 40px;position:relative;&:before{background:", ";content:'';display:block;height:20px;left:0;position:absolute;top:0px;width:4px;}> div[data-testid='avatar']{left:-18px;position:absolute;}textarea{resize:none;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  });

  var ErrorText = _styledComponents.default.span.withConfig({
    displayName: "CommentForm__ErrorText",
    componentId: "sc-2dub3o-1"
  })(["width:100%;> box-icon{fill:", ";height:16px;margin-right:8px;position:relative;top:3px;width:16px;}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.red;
  });

  var CounterText = _styledComponents.default.div.withConfig({
    displayName: "CommentForm__CounterText",
    componentId: "sc-2dub3o-2"
  })(["display:flex;justify-content:flex-end;> span{", " display:block;font-size:1.4em;line-height:20px;margin:8px 0 16px;}"], function (_ref3) {
    var errorMsg = _ref3.errorMsg;
    return errorMsg && (0, _styledComponents.css)(["color:", ";"], function (_ref4) {
      var theme = _ref4.theme;
      return theme.colors.red;
    });
  });

  var Rotation = (0, _styledComponents.keyframes)(["from{transform:rotate(0);}to{transform:rotate(360deg);}"]);

  var StyledButton = _styledComponents.default.button.withConfig({
    displayName: "CommentForm__StyledButton",
    componentId: "sc-2dub3o-3"
  })(["font-weight:bold;max-height:32px;min-width:102px;box-icon{animation:", " 1.5s ", " infinite;position:relative;top:4px;}&:hover{box-icon{fill:", ";}}"], Rotation, function (_ref5) {
    var theme = _ref5.theme;
    return theme.easing.ease;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.write;
  });

  var CommentsForm = function CommentsForm(_ref7) {
    var postComment = _ref7.postComment,
        postCommentState = _ref7.postCommentState,
        commentText = _ref7.commentText,
        setCommentText = _ref7.setCommentText,
        user = _ref7.user,
        placeholderForm = _ref7.placeholderForm,
        error = _ref7.error,
        maxChar = _ref7.maxChar,
        minChar = _ref7.minChar;

    var _useState = (0, _react.useState)(0),
        counter = _useState[0],
        setCounter = _useState[1];

    var _useState2 = (0, _react.useState)(''),
        errorMsg = _useState2[0],
        setErrorMsg = _useState2[1];

    var handleSubmit = function handleSubmit(e) {
      e.preventDefault();

      if (commentText.length < minChar) {
        setErrorMsg(_reactIntlUniversal.default.get('COMENTARIOS.FORM.ERROR_TEXTAREA_POUCO', {
          minChar: minChar
        }));
        return false;
      } else if (commentText.length > maxChar) {
        setErrorMsg(_reactIntlUniversal.default.get('COMENTARIOS.FORM.ERROR_TEXTAREA_MUITO', {
          maxChar: maxChar
        }));
        return false;
      } else {
        setErrorMsg('');
        postComment();
      }
    };

    (0, _react.useEffect)(function () {
      if ((postCommentState == null ? void 0 : postCommentState.status) === 'fulfilled') {
        setCommentText('');
        setCounter(0);
      }

      if ((postCommentState == null ? void 0 : postCommentState.status) === 'rejected') {
        setErrorMsg(_reactIntlUniversal.default.getHTML('COMENTARIOS.FORM.ERROR_TEXTAREA_PADRAO'));
      }
    }, [postCommentState]);

    var handleCounter = function handleCounter(e) {
      var valueText = e.target.value;
      setCommentText(valueText);
      setCounter(valueText.length);

      if (valueText.length > maxChar) {
        setErrorMsg(_reactIntlUniversal.default.get('COMENTARIOS.FORM.ERROR_TEXTAREA_MUITO', {
          maxChar: maxChar
        }));
      } else {
        setErrorMsg('');
      }
    };

    return /*#__PURE__*/_react.default.createElement(FormContainer, {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_.Avatar, {
      kind: user.avatarURL ? 'image' : 'text',
      name: user.nome,
      src: user.avatarURL
    }), /*#__PURE__*/_react.default.createElement(_.TextArea, {
      onChange: function onChange(e) {
        return handleCounter(e);
      },
      placeholder: placeholderForm ? placeholderForm : _reactIntlUniversal.default.get('COMENTARIOS.FORM.PLACEHOLDER'),
      value: commentText
    }), /*#__PURE__*/_react.default.createElement(CounterText, {
      errorMsg: errorMsg || error
    }, errorMsg && /*#__PURE__*/_react.default.createElement(ErrorText, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "x-circle",
      type: "solid"
    }), errorMsg), /*#__PURE__*/_react.default.createElement("span", null, counter, "/", maxChar)), /*#__PURE__*/_react.default.createElement(StyledButton, {
      as: _.Button,
      outline: true,
      kind: "aux",
      scale: "small",
      disabled: (postCommentState == null ? void 0 : postCommentState.status) === 'pending'
    }, /*#__PURE__*/_react.default.createElement("span", null, (postCommentState == null ? void 0 : postCommentState.status) === 'pending' ? /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "loader-alt"
    }) : _reactIntlUniversal.default.get('COMENTARIOS.FORM.BTN_COMENTAR'))));
  };

  CommentsForm.defaultProps = {
    minChar: 2,
    maxChar: 500
  };
  var _default = CommentsForm;
  _exports.default = _default;
});